import React, { Component } from 'react';
import uuidv1 from 'uuid/v1';
import './element-matriz-didatica-properties.css';
import {
  ColorPicker, FontPicker, RelToolbarQuill
} from '../../components';
import PreferenceRequiredInteraction
  from "../../components/preference-required-interaction/preference-required-interaction";

export default class ElementMatrizDidaticaProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content,
      active_tab: "content"
    };

    this.onContentTitleChange = this.onContentTitleChange.bind(this);
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this);
    this.onPaddingTopChange = this.onPaddingTopChange.bind(this);
    this.onPaddingBottomChange = this.onPaddingBottomChange.bind(this);
  }

  onContentTitleChange(e) {
    var content = this.state.content;
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onBackgroundColorChange(color) {
    var content = this.state.content;
    content.background_color = color;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingTopChange(e) {
    var content = this.state.content;
    content.padding_top = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_top;

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingBottomChange(e) {
    var content = this.state.content;
    content.padding_bottom = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_bottom;

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onChangeTab(target) {
    this.setState({
      active_tab: target
    })
  }

  onFontChange(font) {
    var content = this.state.content;
    content.font_family = font;

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  renderFont() {
    var content = this.state.content;
    var labels = this.props.labels;

    if (content.font_family) {
      return <FontPicker font={content.font_family} onFontChange={(font) => this.onFontChange(font)}/>
    } else {
      return <FontPicker hasFont={false} onFontChange={(font) => this.onFontChange(font)} noFontLabel={labels.elements.common_settings.label_no_has_font}/>
    }
  }

  // Painel Consolidado handlers
  onConsolidatedFieldChange(field, value) {
    var content = this.state.content;
    content[field] = value;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onConsolidatedTextChange(field, text) {
    var content = this.state.content;
    content[field] = text;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  // Semanas handlers
  onAddSemana() {
    var content = this.state.content;
    if (!content.semanas) content.semanas = [];
    
    content.semanas.push({
      id: uuidv1(),
      titulo: "",
      objetivo_aprendizagem: "",
      conteudo_programatico: "",
      tipo_material_basico: "",
      titulo_material_basico: "",
      autoria_basico: "",
      quantidade_basico: "",
      fator_basico: "",
      link_basico: "",
      tipo_material_apoio: "",
      titulo_material_apoio: "",
      autoria_apoio: "",
      quantidade_apoio: "",
      fator_apoio: "",
      link_apoio: ""
    });

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onRemoveSemana(index) {
    var content = this.state.content;
    content.semanas.splice(index, 1);
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onDuplicateSemana(index) {
    var content = this.state.content;
    var semanaOriginal = content.semanas[index];
    var novaSemana = { ...semanaOriginal, id: uuidv1() };
    content.semanas.splice(index + 1, 0, novaSemana);
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onSemanaFieldChange(index, field, value) {
    var content = this.state.content;
    content.semanas[index][field] = value;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onSemanaTextChange(index, field, text) {
    var content = this.state.content;
    content.semanas[index][field] = text;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  // Videoaulas handlers
  onAddVideoaula() {
    var content = this.state.content;
    if (!content.videoaulas) content.videoaulas = [];
    
    content.videoaulas.push({
      id: uuidv1(),
      semana: "",
      sequencia: "",
      titulo: "",
      objetivos: "",
      formato: "",
      detalhamento: "",
      referencias: ""
    });

    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onRemoveVideoaula(index) {
    var content = this.state.content;
    content.videoaulas.splice(index, 1);
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onDuplicateVideoaula(index) {
    var content = this.state.content;
    var videoaulaOriginal = content.videoaulas[index];
    var novaVideoaula = { ...videoaulaOriginal, id: uuidv1() };
    content.videoaulas.splice(index + 1, 0, novaVideoaula);
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onVideoaulaFieldChange(index, field, value) {
    var content = this.state.content;
    content.videoaulas[index][field] = value;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onVideoaulaTextChange(index, field, text) {
    var content = this.state.content;
    content.videoaulas[index][field] = text;
    this.setState({
      content: content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  calculateCargaHoraria(quantidade, fator) {
    return quantidade && fator ? (quantidade * fator).toFixed(2) : '0.00';
  }



  renderContent() {
    var activeTab = this.state.active_tab;
    var content = this.state.content;
    var labels = this.props.labels;

    if (activeTab === "content") {
      return (
        <>
          {/* Painel Consolidado */}
          <div className="matriz-didatica-properties-section">
            <h4>Painel Consolidado</h4>
            
            <div className="matriz-didatica-properties-row">
              <div className="matriz-didatica-properties-field">
                <span className="rdp-composer-element-edit-label">Curso:</span>
                <input 
                  type="text" 
                  className="rdp-composer-element-edit-input" 
                  value={content.curso || ""} 
                  onChange={(e) => this.onConsolidatedFieldChange('curso', e.target.value)}
                />
              </div>
              <div className="matriz-didatica-properties-field">
                <span className="rdp-composer-element-edit-label">Carga Horária Total:</span>
                <input 
                  type="text" 
                  className="rdp-composer-element-edit-input" 
                  value={content.carga_horaria_total || ""} 
                  onChange={(e) => this.onConsolidatedFieldChange('carga_horaria_total', e.target.value)}
                />
              </div>
            </div>

            <div className="matriz-didatica-properties-row">
              <div className="matriz-didatica-properties-field">
                <span className="rdp-composer-element-edit-label">Disciplina:</span>
                <input 
                  type="text" 
                  className="rdp-composer-element-edit-input" 
                  value={content.disciplina || ""} 
                  onChange={(e) => this.onConsolidatedFieldChange('disciplina', e.target.value)}
                />
              </div>
              <div className="matriz-didatica-properties-field">
                <span className="rdp-composer-element-edit-label">Docente:</span>
                <input 
                  type="text" 
                  className="rdp-composer-element-edit-input" 
                  value={content.docente || ""} 
                  onChange={(e) => this.onConsolidatedFieldChange('docente', e.target.value)}
                />
              </div>
            </div>

            <div className="matriz-didatica-properties-row">
              <div className="matriz-didatica-properties-field full-width">
                <span className="rdp-composer-element-edit-label">DI Responsável:</span>
                <input 
                  type="text" 
                  className="rdp-composer-element-edit-input" 
                  value={content.di_responsavel || ""} 
                  onChange={(e) => this.onConsolidatedFieldChange('di_responsavel', e.target.value)}
                />
              </div>
            </div>

            <div className="matriz-didatica-properties-row">
              <div className="matriz-didatica-properties-field full-width">
                <span className="rdp-composer-element-edit-label">Ementa:</span>
                <RelToolbarQuill 
                  onChange={(text) => this.onConsolidatedTextChange('ementa', text)} 
                  value={content.ementa || ""} 
                />
              </div>
            </div>

            <div className="matriz-didatica-properties-row">
              <div className="matriz-didatica-properties-field full-width">
                <span className="rdp-composer-element-edit-label">Objetivo Geral:</span>
                <RelToolbarQuill 
                  onChange={(text) => this.onConsolidatedTextChange('objetivo_geral', text)} 
                  value={content.objetivo_geral || ""} 
                />
              </div>
            </div>
          </div>

          {/* Semanas/Módulos */}
          <div className="matriz-didatica-properties-section">
            <h4>Semanas/Módulos</h4>
            
            {content.semanas && content.semanas.map((semana, index) => (
              <div key={semana.id} className="matriz-didatica-properties-item">
                <div className="matriz-didatica-properties-item-header">
                  <span>Semana {index + 1}</span>
                  <div className="matriz-didatica-properties-item-actions">
                    <button type="button" onClick={() => this.onDuplicateSemana(index)} title="Duplicar">📋</button>
                    <button type="button" onClick={() => this.onRemoveSemana(index)} title="Remover">🗑️</button>
                  </div>
                </div>
                
                <div className="matriz-didatica-properties-item-content">
                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Título da semana/módulo:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        value={semana.titulo || ""} 
                        onChange={(e) => this.onSemanaFieldChange(index, 'titulo', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Objetivo de aprendizagem:</span>
                      <RelToolbarQuill 
                        onChange={(text) => this.onSemanaTextChange(index, 'objetivo_aprendizagem', text)} 
                        value={semana.objetivo_aprendizagem || ""} 
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Conteúdo programático:</span>
                      <RelToolbarQuill 
                        onChange={(text) => this.onSemanaTextChange(index, 'conteudo_programatico', text)} 
                        value={semana.conteudo_programatico || ""} 
                      />
                    </div>
                  </div>

                  {/* Material Básico */}
                  <div className="matriz-didatica-properties-material-section">
                    <h5>Material Básico</h5>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Tipo do material básico:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.tipo_material_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'tipo_material_basico', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Título do material básico:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.titulo_material_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'titulo_material_basico', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Autoria:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.autoria_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'autoria_basico', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Quantidade (páginas/minutos):</span>
                        <input 
                          type="number" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.quantidade_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'quantidade_basico', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Fator de conversão:</span>
                        <input 
                          type="number" 
                          step="0.01"
                          className="rdp-composer-element-edit-input" 
                          value={semana.fator_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'fator_basico', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Carga horária estimada:</span>
                        <span className="matriz-didatica-calculated-field">
                          {this.calculateCargaHoraria(semana.quantidade_basico, semana.fator_basico)}h
                        </span>
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field full-width">
                        <span className="rdp-composer-element-edit-label">Link (URL):</span>
                        <input 
                          type="url" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.link_basico || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'link_basico', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Material de Apoio */}
                  <div className="matriz-didatica-properties-material-section">
                    <h5>Material de Apoio</h5>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Tipo do material de apoio:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.tipo_material_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'tipo_material_apoio', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Título do material de apoio:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.titulo_material_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'titulo_material_apoio', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Autoria:</span>
                        <input 
                          type="text" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.autoria_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'autoria_apoio', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Quantidade (páginas/minutos):</span>
                        <input 
                          type="number" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.quantidade_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'quantidade_apoio', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Fator de conversão:</span>
                        <input 
                          type="number" 
                          step="0.01"
                          className="rdp-composer-element-edit-input" 
                          value={semana.fator_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'fator_apoio', e.target.value)}
                        />
                      </div>
                      <div className="matriz-didatica-properties-field">
                        <span className="rdp-composer-element-edit-label">Carga horária estimada:</span>
                        <span className="matriz-didatica-calculated-field">
                          {this.calculateCargaHoraria(semana.quantidade_apoio, semana.fator_apoio)}h
                        </span>
                      </div>
                    </div>
                    <div className="matriz-didatica-properties-row">
                      <div className="matriz-didatica-properties-field full-width">
                        <span className="rdp-composer-element-edit-label">Link (URL):</span>
                        <input 
                          type="url" 
                          className="rdp-composer-element-edit-input" 
                          value={semana.link_apoio || ""} 
                          onChange={(e) => this.onSemanaFieldChange(index, 'link_apoio', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
            <button className="matriz-didatica-properties-add-btn" onClick={() => this.onAddSemana()}>
              Adicionar Semana/Módulo
            </button>
          </div>

          {/* Videoaulas */}
          <div className="matriz-didatica-properties-section">
            <h4>Videoaulas Previstas</h4>
            
            {content.videoaulas && content.videoaulas.map((videoaula, index) => (
              <div key={videoaula.id} className="matriz-didatica-properties-item">
                <div className="matriz-didatica-properties-item-header">
                  <span>Videoaula {index + 1}</span>
                  <div className="matriz-didatica-properties-item-actions">
                    <button type="button" onClick={() => this.onDuplicateVideoaula(index)} title="Duplicar">📋</button>
                    <button type="button" onClick={() => this.onRemoveVideoaula(index)} title="Remover">🗑️</button>
                  </div>
                </div>
                
                <div className="matriz-didatica-properties-item-content">
                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field">
                      <span className="rdp-composer-element-edit-label">Semana:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        value={videoaula.semana || ""} 
                        onChange={(e) => this.onVideoaulaFieldChange(index, 'semana', e.target.value)}
                      />
                    </div>
                    <div className="matriz-didatica-properties-field">
                      <span className="rdp-composer-element-edit-label">Sequência:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        value={videoaula.sequencia || ""} 
                        onChange={(e) => this.onVideoaulaFieldChange(index, 'sequencia', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field">
                      <span className="rdp-composer-element-edit-label">Título:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        value={videoaula.titulo || ""} 
                        onChange={(e) => this.onVideoaulaFieldChange(index, 'titulo', e.target.value)}
                      />
                    </div>
                    <div className="matriz-didatica-properties-field">
                      <span className="rdp-composer-element-edit-label">Formato:</span>
                      <input 
                        type="text" 
                        className="rdp-composer-element-edit-input" 
                        value={videoaula.formato || ""} 
                        onChange={(e) => this.onVideoaulaFieldChange(index, 'formato', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Objetivos:</span>
                      <RelToolbarQuill 
                        onChange={(text) => this.onVideoaulaTextChange(index, 'objetivos', text)} 
                        value={videoaula.objetivos || ""} 
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Detalhamento:</span>
                      <RelToolbarQuill 
                        onChange={(text) => this.onVideoaulaTextChange(index, 'detalhamento', text)} 
                        value={videoaula.detalhamento || ""} 
                      />
                    </div>
                  </div>

                  <div className="matriz-didatica-properties-row">
                    <div className="matriz-didatica-properties-field full-width">
                      <span className="rdp-composer-element-edit-label">Referências e/ou sugestões:</span>
                      <RelToolbarQuill 
                        onChange={(text) => this.onVideoaulaTextChange(index, 'referencias', text)} 
                        value={videoaula.referencias || ""} 
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
            <button className="matriz-didatica-properties-add-btn" onClick={() => this.onAddVideoaula()}>
              Adicionar Videoaula
            </button>
          </div>
        </>
      );
    } else if (activeTab === "configurations") {
      return (
        <div className="matriz-didatica-properties-configurations">
          <span className="rdp-composer-element-edit-label">Título do conteúdo:</span>
          <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onContentTitleChange(e)} defaultValue={content.content_title}></input>

          <span className="rdp-composer-element-edit-label">Cor de fundo:</span>
          <ColorPicker labels={this.props.labels} color={content.background_color} onChange={this.onBackgroundColorChange} />

          <span className="rdp-composer-element-edit-label">Margem superior:</span>
          <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingTopChange(e)} defaultValue={content.padding_top}></input>

          <span className="rdp-composer-element-edit-label">Margem inferior:</span>
          <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingBottomChange(e)} defaultValue={content.padding_bottom}></input>

          <span className="rdp-composer-element-edit-label">Fonte do elemento:</span>
          {this.renderFont()}

          <PreferenceRequiredInteraction
            title={labels.elements.settings.preference_required_interaction.title}
            label={labels.elements.settings.preference_required_interaction.label}
            labels={labels}
            content={content}
            onContentChange={c => {
              this.setState({ content: c });
              this.props.onContentChange(c);
            }}
          />
        </div>
      );
    }
  }

  render() {
    var activeTab = this.state.active_tab;
    var labels = this.props.labels;

    return (
      <div className="rdp-element-matriz-didatica-properties">
        <ul className="rdp-composer-element-edit-tabs">
          <li className={`rdp-composer-element-edit-tabs-item ${activeTab === "content" ? "active" : ""}`} onClick={() => this.onChangeTab("content")}>
            {labels.elements.common_settings.label_tab_content}
          </li>
          <li className={`rdp-composer-element-edit-tabs-item ${activeTab === "configurations" ? "active" : ""}`} onClick={() => this.onChangeTab("configurations")}>
            {labels.elements.common_settings.label_tab_settings}
          </li>
        </ul>
        <div className="rdp-composer-element-edit-body">
          {this.renderContent()}
        </div>
      </div>
    );
  }
}